import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  constructor(private readonly translocoService: TranslocoService) {}

  getLocalizedCountryName(alpha2CountryKey: string): Observable<string> {
    return this.translocoService.langChanges$.pipe(
      map(lang => {
        const intl = new Intl.DisplayNames(lang, { type: 'region' });
        return `${intl.of(alpha2CountryKey)} (${alpha2CountryKey})`;
      }),
      catchError(() => {
        return of(alpha2CountryKey);
      })
    );
  }

  changeLanguageCodeToAdaptAuth0AvailableLanguages(languageCode: string): string {
    const languagesWithRegionInAuth0 = ['zh-CN', 'zh-TW', 'fr-FR', 'fr-CA', 'pt-BR', 'pt-PT'];

    if (languagesWithRegionInAuth0.includes(languageCode)) {
      return languageCode;
    }

    if (languageCode.includes('-')) {
      return languageCode.substring(0, languageCode.indexOf('-'));
    }

    return languageCode;
  }

  isTranslationAvailable(key: string): boolean {
    return this.translocoService.translate(key) !== key;
  }
}
